import { Component } from '@angular/core';
import { HeaderService, Header } from './header.service';
import { ApplicationService } from '../../application/application.service';
import {
  Application,
  MerchantConfig,
  ActiveApplication
} from '../../application/application';
import { environment } from '../../../environments/environment';
import { TokenService } from '../../token/token.service';

import { EventDetails, pageMapping } from '../../common/tracking/aws-tracker';
import { AwsTrackingService } from '../../common/tracking/aws-tracking.service';

declare var $: any;

@Component({
  selector: 'zest-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  public showHeader = 0;
  public showContact = false;
  public application: Application;
  public s3BucketUrl: string = environment.s3BucketUrl;
  public payLater = false;
  public result: Header;
  public downpayment: boolean;
  public showActivate: boolean;
  public dropdownOptions: object[] = [
    {
      inDuration: 500,
      outDuration: 500,
      constrainWidth: false,
      hover: false,
      gutter: 0,
      belowOrigin: false,
      alignment: 'right',
      stopPropagation: true
    }
  ];
  public width = 768;
  public steps: string[];
  public concurrencyStatus: boolean;
  public merchantConfig = new MerchantConfig();
  public showLogout = false;
  public approvedApplications: ActiveApplication[] = new Array<
    ActiveApplication
  >();

  constructor(
    private headerService: HeaderService,
    private tokenService: TokenService,
    private applicationService: ApplicationService,
    private awsTrackingService: AwsTrackingService
  ) {
    this.headerService.ShowHeaderSource.subscribe(result => {
      this.getApplication(result);
    });
  }

  toggleHeader(header: Header) {
    header.stepProgress = 0;
    const interval = setInterval(fn => {
      this.application = this.applicationService.getApplication();
      const routeConfig = this.applicationService.getRouteConfig();
      if (this.application && this.applicationService.getRouteConfig()) {
        this.steps = this.applicationService.getStepsConfig();
        if (this.application) {
          if (
            this.application.DownpaymentAmount +
              this.application.ProcessingFee ===
            0
          ) {
            if (this.steps) {
              const dpIndex = this.steps.indexOf('Downpayment');
              if (dpIndex > -1) {
                this.steps.splice(dpIndex, 1);
              }
            }
          }
          header.stepProgress = this.steps.indexOf(header.step);
        }
      } else if (routeConfig) {
        this.downpayment = false;
        this.steps = this.applicationService.getStepsConfig();
        header.stepProgress = this.steps.indexOf(header.step);
      }
      this.showHeader = header.showHeaderBar;
      this.showContact = header.showContact;
      this.result = header;
      this.getMerchantConfig();
      if (this.tokenService.getToken()) {
        this.showLogout = true;
      }
      const content = document.getElementById('page-content');
      if (this.showHeader) {
        content.classList.add('padding-top');
      } else {
        content.classList.remove('padding-top');
      }
      clearInterval(interval);
    }, 100);
    this.onResize();
  }
  getApplication(result) {
    this.application = this.applicationService.getApplication();
    this.getActiveApplications();
    if (this.application !== null) {
      if (
        this.application.DownpaymentAmount + this.application.ProcessingFee ===
        0
      ) {
        this.downpayment = false;
      } else {
        this.downpayment = true;
      }
      if (this.applicationService.getConcurrency()) {
        const concurrency = this.applicationService.getConcurrency();
        this.concurrencyStatus = concurrency['status'];
      }
    }
    this.result = result;
    this.toggleHeader(result);
  }
  showModal() {
    const event = new EventDetails('Logout', 'click', 'triggered');
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event);
    setTimeout(fn => {
      $('#logout').modal('open');
    }, 0);
  }
  closeModal() {
    setTimeout(fn => {
      $('#logout').modal('close');
    }, 0);
  }
  logout() {
    this.tokenService.logout();
  }
  onResize() {
    this.width = window.innerWidth;
  }
  goToYourAccounts() {
    const param = this.tokenService.getParamString();
    const url = environment.youraccountUrl + '/dashboard#' + param;
    window.open(url, '_blank');
  }
  getMerchantConfig() {
    this.merchantConfig = this.tokenService.getMerchantConfig();
  }
  getActiveApplications() {
    if (this.tokenService.getCustomerId()) {
      this.applicationService.getActiveApplications().subscribe(
        applications => {
          this.approvedApplications = applications.filter(
            application =>
              application.Status === 'Approved' &&
              (application.LoanStatus === null ||
                application.LoanStatus === 'Approved')
          );
          if (this.application) {
            const currentApplication = this.approvedApplications.filter(
              approvedApplication =>
                approvedApplication.ExternalId ===
                this.application.ApplicationId
            );
            if (currentApplication && currentApplication.length > 0) {
              this.approvedApplications = this.approvedApplications.filter(
                approvedApplication =>
                  approvedApplication.ExternalId !==
                  this.application.ApplicationId
              );
            }
          }
        },
        error => {
          if (error.status === 401) {
            this.tokenService.removeAll(false);
            // Unauthorized
          }
        }
      );
    }
  }

  trackClick() {
    const page = ((location.pathname).split('/')[1] === 'dashboard') ? 'dashboard' : (location.pathname).split('/')[2];
    const event = new EventDetails('ViewAction', 'click', 'triggered');
    const props = {
      Action: 'Hamburger',
      View: pageMapping[page]
    };
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
  }
}
